import React from "react";
import ResourceListPage from "commons/components/ResourceListPage";
import { IconButton } from "@material-ui/core";
import { Link } from "react-router-dom";
import { Language } from "@material-ui/icons";

const columns = [
  {
    name: "name",
    type: "text",
    sortable: true,
    searchable: true,
  },
  {
    name: "counter",
    type: "number",
    sortable: true,
    searchable: true,
  },
  {
    name: "language",
    type: "text",
    sortable: true,
    searchable: true,
    searchKey: "languages.name",
  },
];

export default function List() {
  return (
    <ResourceListPage
      url="print-templates"
      columns={columns}
      actions={
        <IconButton component={Link} to={`/s/languages`}>
          <Language />
        </IconButton>
      }
    />
  );
}
